import type { ReactNode } from 'react'
import {
  PromptInputButton,
  PromptInputFooter,
  PromptInputTools,
} from '@/components/ai-elements/prompt-input-footer'
import { PlusIcon } from '@/components/chat/icons'
import { InputGroup } from '@/components/ui/input-group'

/**
 * The demo's frame, shared by the loading poster (`lazy-product-demo.tsx`)
 * and the demo itself, so nothing shifts when the demo mounts. Light on
 * purpose: the poster ships in the page's own JS.
 */
export const DEMO_FRAME_CLASS =
  'flex h-full min-h-0 w-full overflow-hidden rounded-2xl border border-border bg-background'
export const DEMO_CHAT_COLUMN_CLASS =
  'flex w-[360px] shrink-0 flex-col border-border border-r bg-canvas'
/** Where the composer sits in the chat column (the chat panel's padding). */
export const DEMO_COMPOSER_SLOT_CLASS = 'shrink-0 px-3 pb-3'

/** lucide `size-4` at its default stroke: a 4/3px line at 16px. */
const PLUS_ICON_STROKE = 4 / 3

/**
 * The chat panel composer's shell (`InputGroup`, then the footer with "+"
 * and the submit), around an editable the caller supplies. It translates
 * nothing itself: the poster renders it before the demo's catalogs load.
 */
export function DemoComposerShell({
  textarea,
  submit,
  addLabel,
  onAdd,
}: {
  textarea: ReactNode
  submit?: ReactNode
  /** The "+" button's name; the poster, hidden from assistive tech, has none. */
  addLabel?: string
  /** The "+" (attachments need an account). */
  onAdd?: () => void
}) {
  return (
    <InputGroup>
      {textarea}
      <PromptInputFooter>
        <PromptInputTools>
          <PromptInputButton aria-label={addLabel} onClick={onAdd}>
            <PlusIcon size={16} strokeWidth={PLUS_ICON_STROKE} />
          </PromptInputButton>
        </PromptInputTools>
        {submit}
      </PromptInputFooter>
    </InputGroup>
  )
}
